import {Lawyer} from './Lawyer';
import {Nomenclature} from './Nomenclature';
import {FrxBaseBean} from './frxbasebean';
export class Nakazatelno extends FrxBaseBean {

	instance: Nomenclature;
	city: Nomenclature;
	court: Nomenclature;
	'number': string;
	dataNasrocheno;
	timeNasrocheno: string;
	status: Nomenclature;
	note: string;
	lawsuiteId: number;
	prokusrorskaPrepiskaNomer: string;
	zmMvrNomer: string;
	lawyer: Lawyer;

	sudiaDokladchik: string;
	
	copy(source: Nakazatelno) {
		super.copy(source);
		this.number = source.number;
		this.prokusrorskaPrepiskaNomer = source.prokusrorskaPrepiskaNomer;
		this.zmMvrNomer = source.zmMvrNomer;
		this.dataNasrocheno = source.dataNasrocheno;
		this.timeNasrocheno = source.timeNasrocheno;
		this.status = source.status;
		this.lawyer = source.lawyer;
		this.instance = source.instance;
		this.city = source.city;
		this.court = source.court;
		this.note = source.note;
		this.sudiaDokladchik = source.sudiaDokladchik
	}
}
